/**
 * Mail App Definition
 * 
 * Universal Inbox & Mail System for RiverOS
 * Starts as Gmail client, evolves into multi-channel inbox
 */

import { AppDefinition } from '../../types/apps';

export const MailAppDefinition: AppDefinition = {
  appId: 'mail',
  name: 'Mail',
  version: '1.0.0',
  description: 'Email client with threading, smart labels, and broadcasts',
  
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Envelope',
    phosphorWeight: 'duotone',
    color: '#ec4899',
  },
  
  supportedFileTypes: [],
  
  entityTypes: [
    'Mail.Thread',
    'Mail.Message',
    'Mail.Contact',
    'Mail.Audience',
    'Mail.Broadcast',
    'Mail.Draft',
    'Mail.SmartFolder',
  ],
  
  component: 'MailApp',
  requiresProps: false,
  requiresEntity: false,
  
  // Entity icons
  entityIcons: {
    'Mail.Thread': {
      type: 'phosphor',
      phosphorIcon: 'ChatCircleDots',
      phosphorWeight: 'duotone',
    },
    'Mail.Message': {
      type: 'phosphor',
      phosphorIcon: 'Envelope',
      phosphorWeight: 'duotone',
    },
    'Mail.Contact': {
      type: 'phosphor',
      phosphorIcon: 'User',
      phosphorWeight: 'duotone',
    },
    'Mail.Audience': {
      type: 'phosphor',
      phosphorIcon: 'Users',
      phosphorWeight: 'duotone',
    },
    'Mail.Broadcast': {
      type: 'phosphor',
      phosphorIcon: 'Megaphone',
      phosphorWeight: 'duotone',
    },
    'Mail.Draft': {
      type: 'phosphor',
      phosphorIcon: 'EnvelopeSimple',
      phosphorWeight: 'duotone',
    },
    'Mail.SmartFolder': {
      type: 'phosphor',
      phosphorIcon: 'FolderStar',
      phosphorWeight: 'duotone',
    },
  },
  
  // Keyboard shortcuts
  hotkeys: {
    'c': 'compose',
    'r': 'reply',
    'a': 'replyAll',
    'f': 'forward',
    'e': 'archive',
    '#': 'delete',
    's': 'star',
    'u': 'markUnread',
  },
  
  features: [
    'Threading conversations',
    'Smart labels with AI',
    'AI-powered draft replies',
    'Broadcast emails to audiences',
    'Open emails in Spaces',
    'Real-time sync',
  ],
  
  actions: {},
};
